import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { InputBlock } from 'ecs-react-components/dist/index.es';
import { messages } from './Address.i18n';

class Address extends React.Component {
  constructor(props) {
    super(props);
    this.state = { filteredStates: props.states, usePatientAddress: this.props.fields.usePatientAddress.value };
  }

  onCountryChange = (newValue) => {
    let filteredStates = this.props.states;
    const newCountry = this.props.countries.find((x) => x.countryNameDisplay === newValue);
    if (newValue && newCountry) {
      filteredStates = this.props.states.filter(
        (state) => state.countryId === 0 || state.countryId.toString() === newCountry.countryId.toString());
    }
    this.setState({ filteredStates });
  }

  onUsePatientAddressChange = (event) => {
    this.setState({ usePatientAddress: event.target.checked });
    this.props.onUsePatientAddressClick(event);
    this.props.fields.usePatientAddress.input.onChange(event);
  }

  render() {
    const countryOptions = this.props.countries.map((c) => {
      const option = {};
      option.key = c.countryNameDisplay;
      option.value = c.countryNameDisplay;
      option.displayValue = c.countryNameDisplay;
      return option;
    });

    const { formatMessage } = this.props.intl;

    const stateOptions = this.state.filteredStates.map((s) => {
      const option = {};
      option.key = s.stateNameDisplay;
      option.value = s.stateNameDisplay;
      option.displayValue = s.stateNameDisplay;
      return option;
    });

    return (
      <div className="contact-section">
        <h3 tabIndex="0"><FormattedMessage { ...messages.title } /></h3>
        <div className="row">
          <div className="form-group col-xs-12 col-md-6">
          <div className="checkbox largefont nomargin">
            <label>
                <input type="checkbox"
                  onChange={this.onUsePatientAddressChange}
                  id={this.props.fields.usePatientAddress.input.name}
                  value={this.props.fields.usePatientAddress.input.value}
                  { ...(this.props.fields.usePatientAddress.input.value ? { checked: 'checked' } : {})}
                /><FormattedMessage { ...messages.label.usePatientAddress } />
            </label>
          </div>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-xs-12 col-md-6">
            <InputBlock
              id="address1"
              labelText={ <FormattedMessage { ...messages.label.address1 } /> }
              type="text"
              field={ this.props.fields.address1}
              xsSize={12} mdSize={12}
              disabled={this.state.usePatientAddress}
              formGroup={false}
            />
          </div>
          <div className="form-group col-xs-12 col-md-6">
            <InputBlock
              id="address2"
              labelText={ <FormattedMessage { ...messages.label.address2 } /> }
              type="text"
              field={ this.props.fields.address2}
              xsSize={12} mdSize={12}
              disabled={this.state.usePatientAddress}
              formGroup={false}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-xs-12 col-md-6">
            <InputBlock
              id="city"
              labelText={ <FormattedMessage { ...messages.label.city } /> }
              type="text"
              field={ this.props.fields.city}
              xsSize={12} mdSize={12}
              disabled={this.state.usePatientAddress}
              formGroup={false}
            />
          </div>
          <div className="form-group col-xs-12 col-md-6">
            <InputBlock
              id="zipCode"
              labelText={ <FormattedMessage { ...messages.label.zipcode } /> }
              type="text"
              field={ this.props.fields.zipCode}
              xsSize={12} mdSize={12}
              disabled={this.state.usePatientAddress}
              formGroup={false}
              maxLength={20}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-xs-12 col-md-6">
            <InputBlock
              id="state"
              labelText={ <FormattedMessage { ...messages.label.state } /> }
              type="select"
              field={ this.props.fields.state}
              options={stateOptions}
              xsSize={12} mdSize={12}
              placeHolder={formatMessage(messages.label.selectOne)}
              disabled={this.state.usePatientAddress}
              formGroup={false}
            />
          </div>
          <div className="form-group col-xs-12 col-md-6">
            <InputBlock
              id="country"
              labelText={ <FormattedMessage { ...messages.label.country } /> }
              type="select"
              field={ this.props.fields.country}
              options={countryOptions}
              xsSize={12} mdSize={12}
              placeHolder={formatMessage(messages.label.selectOne)}
              onChange={this.onCountryChange}
              disabled={this.state.usePatientAddress}
              formGroup={false}
            />
          </div>
        </div>
      </div>
    );
  }
}

Address.propTypes = {
  fields: PropTypes.object,
  countries: PropTypes.array,
  states: PropTypes.array,
  intl: PropTypes.object,
  patientAddress: PropTypes.object,
  onUsePatientAddressClick: PropTypes.func,
};

export default (injectIntl(Address));